import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bold",
  templateUrl: "./med-icon-bold.component.html",
})
export class MedIconBoldComponent extends SvgMixinComponent {}
